import React,{ useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Layout, Col, Row, Divider } from 'antd';

import BigCard from '../../../components/BigCard/BigCard';
import CardDom from '../../../components/CardDom/CardDom';
import PhotoWall from '../../../components/PhotoWall/PhotoWall';

import './Testimonials.less'

const Testimonials = () =>{
  const navigate = useNavigate();

  let bigCardData = {
    type: 'bgCard',
    bgImg: require('../../../image/bigCardBg-3840x1440.png'),
    textWidth: '30%',
    textPosition: 'right',
    title: '线粒体能量工厂',
    description: '通过激活线粒体功能，改善口腔与肺部细胞代谢，有效预防和缓解牙周炎、肺纤维化、口腔溃疡等健康问题，为呼吸健康筑起屏障。',
    btnConfig:{
      text: 'shop all',
      link: '/shop'
    }
  }

  let expertList = [{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  }]

  let PhotoWallData = {
    drawer: false,
    title: 'Scientists, Doctors, Longevity Experts',
    titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
    subTitle: 'Recommended by',
    subTitleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    subTitle2: '',
    description: '',
    descriptionSize: '',
    data: expertList
  }

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])
  return (
    <div className="Testimonials-page">
      {width > 770? 
        <div className="bigTitle">
          Reviewed & recommended
        </div>
        :
        <div style={{width: '100%', maxWidth: 1440, fontSize: 'clamp(40px, calc(31.55px + 2.25vw), 64px)', padding: '30px 25px 0'}}>
          Reviewed & recommended
        </div>
      }

      {/* 专家照片墙 */}
      <PhotoWall PhotoWallData={PhotoWallData}/>

      <BigCard bigCardData={bigCardData}/>
    </div>
  )
}

export default Testimonials